define('presentation/settings/liveReceptionistScripts/presentationObjects/liveReceptionistScriptsPresentationObject',[
    'constants/liveReceptionistQueueHoldSettingConstants',
    'constants/liveReceptionistScriptTransferOptionConstants',
    'constants/liveReceptionistScriptWarmTransferCallerIdConstants',
    'constants/liveReceptionistScriptTransferSelectionTypeConstants',
    'constants/liveReceptionistScriptConstants',
    'constants/liveReceptionistScriptTypeConstants',
    'constants/systemObjectIconNameConstants'
], function() {
    const LiveReceptionistQueueHoldSettingConstants = require('constants/liveReceptionistQueueHoldSettingConstants');
    const LiveReceptionistWarmTransferCallerIdConstants = require('constants/liveReceptionistScriptWarmTransferCallerIdConstants');
    const LiveReceptionistTransferOptionConstants = require('constants/liveReceptionistScriptTransferOptionConstants');
    const LiveReceptionistScriptTransferSelectionTypeConstants = require('constants/liveReceptionistScriptTransferSelectionTypeConstants');
    const LiveReceptionistScriptConstants = require('constants/liveReceptionistScriptConstants');
    const LiveReceptionistScriptTypeConstants = require('constants/liveReceptionistScriptTypeConstants');

    const _systemObjectIconNames = require('constants/systemObjectIconNameConstants');

    return function(){
        const self = this;

        const _i18n = require('i18next');

        self.liveReceptionistScriptId = null;
        self.liveReceptionistPortalScriptId = null;
        self.liveReceptionistPortalScriptUrl = null;
        self.liveReceptionistScriptName = null;
        self.liveReceptionistQueueId = null;
        self.liveReceptionistQueueHoldSetting = LiveReceptionistQueueHoldSettingConstants.HoldMusic;
        self.liveReceptionistWarmTransferCallerId = LiveReceptionistWarmTransferCallerIdConstants.CustomerServiceNumber;
        self.liveReceptionistManualEntryTransferOptions = LiveReceptionistTransferOptionConstants.None;

        self.liveReceptionistUserTransferOptions = LiveReceptionistTransferOptionConstants.None;
        self.liveReceptionistUserTransferSelectionType = LiveReceptionistScriptTransferSelectionTypeConstants.All;
        self.liveReceptionistSelectedUserIds = [];
        self.liveReceptionistUserGroupTransferOptions = LiveReceptionistTransferOptionConstants.None;
        self.liveReceptionistUserGroupTransferSelectionType = LiveReceptionistScriptTransferSelectionTypeConstants.All;
        self.liveReceptionistSelectedUserGroupIds = [];
        self.liveReceptionistForwardingNumberTransferOptions = LiveReceptionistTransferOptionConstants.None;
        self.liveReceptionistForwardingNumberTransferSelectionType = LiveReceptionistScriptTransferSelectionTypeConstants.All;
        self.liveReceptionistSelectedForwardingNumberIds = [];
        self.liveReceptionistVoicemailBoxTransferOptions = LiveReceptionistTransferOptionConstants.None;
        self.liveReceptionistVoicemailBoxTransferSelectionType = LiveReceptionistScriptTransferSelectionTypeConstants.All;
        self.liveReceptionistSelectedVoicemailBoxIds = [];

        self.status = ko.observable(null);
        self.isPendingStatus = ko.pureComputed(() => self.status() === LiveReceptionistScriptConstants.status.pending.id);
        self.isDeactivatedStatus = ko.pureComputed(() => self.status() === LiveReceptionistScriptConstants.status.deactivated.id);
        self.statusLabel = ko.pureComputed(() => {
            switch (self.status()) {
                case LiveReceptionistScriptConstants.status.active.id:
                    return LiveReceptionistScriptConstants.status.active.name;
                case LiveReceptionistScriptConstants.status.pending.id:
                    return LiveReceptionistScriptConstants.status.pending.name;
                case LiveReceptionistScriptConstants.status.deactivated.id:
                    return LiveReceptionistScriptConstants.status.deactivated.name;
            }
        });
        self.type = ko.observable(null);
        self.typeIconName = ko.pureComputed(() => {
            switch (self.type()) {
                case LiveReceptionistScriptTypeConstants.LiveReceptionist:
                    return _systemObjectIconNames.hostedNumber;
                case LiveReceptionistScriptTypeConstants.WebChat:
                    return _systemObjectIconNames.webChatWidget;
                case LiveReceptionistScriptTypeConstants.OutboundCalling:
                    return _systemObjectIconNames.outboundCallingCampaign;
            }
        });
        self.schedule = null;
        self.createdDateTime = null;
        self.updatedDateTime = null;
        self.editLiveReceptionistScriptUrl = null;
        self.shouldDisplayLiveReceptionistScript = ko.observable(false);

        self.deactivateTooltipText = ko.pureComputed(() => {
            if (self.isPendingStatus()) {
                return _i18n.t('liveReceptionistScripts:deactivatePending');
            } else {
                return _i18n.t('liveReceptionistScripts:deactivate');
            }
        });

        self.reactivateTooltipText = ko.observable(_i18n.t('liveReceptionistScripts:reactivate'));
    };
});

